//import "antd/dist/antd.css";
// import "antd/dist/antd.min.css";
import "./App.css";
import "./menu2.css";
import { Menu } from "antd";
// import React from 'react';
import { slide as Menu2 } from 'react-burger-menu';
// import {Routes} from './routes/Routes';
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  HomeOutlined,
  UnorderedListOutlined,
  UserOutlined,
  PoweroffOutlined,
} from "@ant-design/icons/lib/icons";
//import HookMqtt from './components/Hook';
import Iot1 from "./components/Iot1";
import Iot2 from "./components/Iot2";
// import HooksPersonalizados from "./components/HooksPersonalizados";
// import Hw1 from "./components/Hw1";
// import LineChart from "./components/LineChart";

import Hw2 from "./components/Hw2";
import Hw3 from "./components/Hw3";
import Hw4 from "./components/Hw4";
import Hw5 from "./components/Hw5";
import Header from "./components/Header";
// import Hw3ItemDetailContainer from "./components/Hw3ItemDetailContainer";
import Hw3ItemDetailContainer from "./components/Hw3/Hw3ItemDetailContainer";
// import Hw3ItemDetailContainer from "./components/Hw3/Hw3ItemDetailContainer";
import AddItem from "./components/AddItem";
import AddFile from "./components/AddFile";
import FloatMenu from "./components/FloatMenu";
import SideMenu1 from "./components/SideMenu1";
import SideMenu2 from "./components/SideMenu2";

  // class Example extends React.Component {

//} from "@ant-design/icons";

function App() {
  const navigate = useNavigate();

  
    return (
    <div
      // style={{
      //   display: "flex",
      //   flexDirection: "column",
      //   flex: 1,
      //   height: "100vh",
      // }}
    >
      <Header />
      <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        {/* <SideMenu1 /> */}
        <SideMenu2 />
        {/* <Content /> */}
      </div>
        {/* <div className="menu"> */}
        {/* <SideMenu /> */}
        {/* <Menu2 isOpen={isOpen} onOpen={handleIsOpen} onClose={handleIsOpen}> */}
        {/*<Menu2 width={ '10%' } >
         <a id="home" className="menu-item" href="/">Home</a>
        <a id="about" className="menu-item" href="/Hw2">Hw2</a>
        <a id="contact" className="menu-item" href="/Hw3">Hw3</a>
        <a id="contact" className="menu-item" href="/Hw4">Hw4</a>
        <a id="contact" className="menu-item" href="/Hw5">Hw5</a> 
        <a id="home" className="menu-item" onClick={()=>navigate("/")} >Home</a>
        <a id="Hw2" className="menu-item"  onClick={()=>navigate("/Hw2")} >Hw2</a>
        <a id="Hw3" className="menu-item"  onClick={()=>navigate("/Hw3")} >Hw3</a>
        <a id="Hw4" className="menu-item"  onClick={()=>navigate("/Hw4")} >Hw4</a>
        <a id="Hw5" className="menu-item" href="/Hw5">Hw5</a>
      </Menu2> */}
        {/* <a onClick={ this.showSettings } className="menu-item--small" href="">Settings</a> */}
        {/* </div> */}
      {/* <FloatMenu /> */}
        <Content />
      {/* <Footer /> */}
    </div>
  );
}

// function Header() {
//   return (
//     <div
//       style={{
//         height: 60,
//         backgroundColor: "lightskyblue",
//         color: "white",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         fontWeight: "bold",
//       }}
//     >
//       Header
//     </div>
//   );
// }

function Footer() {
  return (
    <div
      style={{
        height: 60,
        backgroundColor: "lightgray",
        color: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
      }}
    >
      Footer
    </div>
  );
}

// function SideMenu() {
//   const navigate = useNavigate();
//   //console.log(window.screen.orientation);
//   return (
//     //<Menu theme="dark" mode="horizontal"
//     <Menu 
//      mode="horizontal"
//     //mode="vertical"
//       onClick={({ key }) => {
//         if (key === "signout") {
//           //TODO, sign out feature here
//         } else {
//           navigate(key);
//         }
//       }}
//       defaultSelectedKeys={[window.location.pathname]}
//       items={[
//         { label: "Home", key: "/", icon: <HomeOutlined /> },
//         //{ label: "Home", key: "/" },
//         {
//           label: "LineChart",
//           key: "/LineChart",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Hw2",
//           key: "/hw2",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Hw3",
//           key: "/hw3",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Hw4",
//           key: "/hw4",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Hw5",
//           key: "/hw5",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Dash1",
//           key: "/dash1",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Dash2",
//           key: "/dash2",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Iot 1",
//           key: "/iot1",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "Iot 2",
//           key: "/iot2",
//           icon: <DashboardOutlined />,
//         },
//         {
//           label: "User List",
//           key: "/userList",
//           icon: <UnorderedListOutlined />,
//           children: [
//             { label: "Active Userss", key: "/activeUsers" },
//             { label: "Disabled Users", key: "/disabledUsers" },
//           ],
//         },
//         { 
//           label: "Profile", 
//           key: "/profile", 
//           icon: <UserOutlined /> 
//         },
//         {
//           label: "Singout",
//           key: "signout",
//           icon: <PoweroffOutlined />,
//           danger: true,
//         },
//       ]}
//     ></Menu>
//   );
// }

function Home() {
  return <div>Home Component</div>;
}

function Content() {
// const baseURL = process.env.PUBLIC_URL;
  return (
    <div className="Contenido">
      <Routes>
      {/* <Route exact path="${baseURL}/" component={Login} /> */}
      {/* <Route path="/" element={<Home />}></Route> */}
        {/* <Route path="/hw1" element={<Hw1 />}></Route>
        <Route path="/hw2" element={<Hw2 />}></Route>
        <Route path="/hw3" element={<Hw3 />}></Route>
        <Route path="/hw4" element={<Hw4 />}></Route> 
        <Route path="/hw5" element={<Hw5 />}></Route> 
        <Route path="/dash1" element={<div> */}
        <Route path="/" element={<Home />}></Route>
        {/* <Route path="/hw1" element={<Hw1 />}></Route> */}
        {/* <Route path="/LineChart" element={<LineChart />}></Route> */}
        
        <Route path="/hw2" element={<Hw2 />}></Route>
        <Route path="/hw3" element={<Hw3 />}></Route>
        <Route path="/hw4" element={<Hw4 />}></Route> 
        <Route path="/hw5" element={<Hw5 />}></Route>
        <Route path="/detalle/:detalleId" element={<Hw3ItemDetailContainer />}/>
        <Route path="/addItem" element={<AddItem />}/>
        <Route path="/AddFile" element={<AddFile />}/>

        <Route path="/dash1" element={<div>{/* <HooksPersonalizados/> */}</div>}></Route>
        {/* <Route path="/dash2" element={<HookMqtt />}></Route> */}
        <Route path="/iot1" element={<Iot1 />}></Route>
        <Route path="/iot2" element={<Iot2 />}></Route>
        <Route path="/activeUsers" element={<div>Active Users List</div>}></Route>
        <Route path="/disabledUsers" element={<div>Disabled Users List</div>}></Route>
        <Route path="/profile" element={<div>Profile</div>}></Route>
      </Routes>
    </div>
  );
}

export default App;

// import React from 'react';
// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
